import React from 'react';

import { usePokCore } from '../../../common/hooks/usePokCore';

import { Option, Selector } from './Selector';

export interface SurveySelectorProps {
  value?: string;
  readOnly?: boolean;
  clearable?: boolean;
  onChange?: (option: Option | null) => void;
}

export const SurveySelector: React.FC<SurveySelectorProps> = props => {
  const pok = usePokCore();

  const provider = async (text: string) => {
    const surveys = await pok.surveys.getAllByNamePattern(text);
    return surveys.map(s => ({ value: s.id, label: s.name }) as Option);
  };

  return (
    <Selector
      uniqueKey={'surv-' + (props.value ?? 'new')}
      readOnly={props.readOnly}
      creatable={false}
      clearable={props.clearable}
      provider={provider}
      value={props.value}
      //   deletedValueName={async id => {
      //     const surveys = await pok.surveys.getAllByNamePattern('', 1000);
      //     const name = surveys.find(s => s.id === id)?.name ?? id;
      //     return { value: id, label: name } as Option;
      //   }}
      onChange={option =>
        props.onChange && props.onChange(option as Option | null)
      }
    />
  );
};
